var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.9714,
    cy: 29.2947,
    r: 27.635,
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8615 44.625C31.5556 44.626 31.2533 44.5593 30.9769 44.4297C30.7005 44.3002 30.4569 44.111 30.2642 43.8762L20.3731 31.7337C20.0719 31.3716 19.9072 30.9174 19.9072 30.4486C19.9072 29.9799 20.0719 29.5256 20.3731 29.1635L30.6123 17.021C30.9599 16.6077 31.4594 16.3478 32.0009 16.2985C32.5424 16.2491 33.0816 16.4144 33.4998 16.7579C33.918 17.1014 34.181 17.595 34.2309 18.1302C34.2808 18.6653 34.1136 19.1981 33.766 19.6114L24.6121 30.4587L33.4588 41.3061C33.7092 41.6031 33.8683 41.9648 33.9172 42.3484C33.9661 42.732 33.9028 43.1215 33.7348 43.4706C33.5667 43.8198 33.301 44.114 32.969 44.3186C32.637 44.5232 32.2527 44.6295 31.8615 44.625Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.a09451d5113cae6a241d01a14d193957.svg";
export { ForwardRef as ReactComponent };